<template>
  <transition
    name="slide-right"
    mode="out-in"
  >
    <div
      v-if="isShown"
      class="position-fixed right-0 mt-5 me-5"
    >
      <div
        class="alert alert-primary"
        role="alert"
      >
        {{ message }}
      </div>
    </div>
  </transition>
</template>
<script>
import { routing } from '@/mixins';

export default {
  name: 'CommonToast',
  mixins: [routing],
  computed: {
    isShown() {
      return this.$store.state.ui.toast.show;
    },
    message() {
      return this.$store.state.ui.toast.message;
    },
  },
};
</script>
<style scoped>
.right-0 {
  z-index: 2000;
  right:0;
  top: 0;
}
.alert {
  max-width: 250px;
}
</style>
